module.exports = __webpack_public_path__ + "img/20200513_152952.16a164f8.jpg";